import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import { VueQueryPlugin } from '@tanstack/vue-query'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'

import App from './App.vue'
import router from './router'
import { primeVueConfig } from './config/primevue'

// PrimeIcons CSS - ensure it loads before other styles
import 'primeicons/primeicons.css'
import './assets/main.css'

const app = createApp(App)
const pinia = createPinia()

// Configure PrimeVue with custom theme
app.use(PrimeVue, primeVueConfig)

// Configure TanStack Query
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        retryOnMount: true,
      },
      mutations: {
        retry: 0, // Don't retry mutations by default
      },
    },
  },
})

// PrimeVue services
app.use(ToastService)
app.use(ConfirmationService)
app.directive('tooltip', Tooltip)

app.use(pinia)
app.use(router)

app.mount('#app')

// Prevent FOUC - show body after Vue is mounted
document.body.classList.add('loaded')

